<script lang="ts">
	import * as m from '$lib/paraglide/messages';

	// Href oryginału EN — pełny reload, bo zmienia locale (statyczna strona).
	let { enHref }: { enHref: string } = $props();
</script>

<div class="fallback-banner" role="note">
	<p>
		{m.wiki_fallback_banner()}
		<a href={enHref} data-sveltekit-reload>{m.wiki_fallback_banner_link()}</a>
	</p>
</div>

<style>
	.fallback-banner {
		border: 1px solid var(--v3-border);
		background: var(--v3-surface);
		color: var(--v3-muted);
		border-radius: 0.75rem;
		padding: 0.75rem 1rem;
		margin-bottom: 1.5rem;
		font-size: 0.9rem;
	}
	.fallback-banner p {
		margin: 0;
	}
	.fallback-banner a {
		color: var(--v3-text);
		font-weight: 600;
	}
</style>
